export default {
  data() {
    return {
      lastTime: 0,
      endTime: 0,
      countdownResult: {},
    }
  },
  methods: {
    startCountdown(showDay) {
      const countdownFn = (currentTime) => {
        // 避免过于频繁的更新
        if (currentTime - this.lastTime >= 1000) {
          const remainingTime = this.endTime - Date.now()

          if (remainingTime <= 0) {
            if (showDay) {
              this.countdownResult = {
                days: '00',
                hours: '00',
                minutes: '00',
                seconds: '00',
              }
              return
            }
            if (!showDay) {
              this.countdownResult = {
                hours: '00',
                minutes: '00',
                seconds: '00',
              }
              return
            }
          }

          if (showDay) {
            this.countdownResult = this.formatCountDownDHMS(remainingTime)
          }
          if (!showDay) {
            this.countdownResult = this.formatCountDownHMS(remainingTime)
          }

          this.lastTime = currentTime
        }

        // 继续下一帧
        this.animationFrameId = requestAnimationFrame(countdownFn)
      }

      this.animationFrameId = requestAnimationFrame(countdownFn)
    },
    // 格式化时间显示
    formatCountDownHMS(ms) {
      if (ms <= 0) {
        return {
          hours: '00',
          minutes: '00',
          seconds: '00',
        }
      }

      const totalSeconds = Math.floor(ms / 1000)
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60

      return {
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0'),
      }
    },
    // 格式化时间显示
    formatCountDownDHMS(ms) {
      if (ms <= 0) {
        return {
          days: '00',
          hours: '00',
          minutes: '00',
          seconds: '00',
        }
      }

      const totalSeconds = ms / 1000
      let lastSec = 0

      const days = Math.floor(totalSeconds / 86400)
      lastSec = totalSeconds % 86400

      const hours = Math.floor(lastSec / 3600)
      lastSec = lastSec % 3600

      const minutes = Math.floor(lastSec / 60)
      const seconds = Math.floor(lastSec % 60)

      return {
        days: String(days).padStart(2, '0'),
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0'),
      }
    },
    initCountDown(targetTime, showDay, useTimemills) {
      try {
        // 使用时间戳
        if (useTimemills) {
          this.endTime = targetTime
        }
        // 使用秒
        else {
          this.endTime = Date.now() + targetTime * 1000
        }
        this.startCountdown(showDay)
      } catch (err) {
        this.showTime = ''
      }
    },
  },
}
